import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tournament-info",
  "data-qe-id": "tournament-info"
}
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = {
  key: 0,
  class: "headline"
}
const _hoisted_4 = {
  key: 1,
  class: "flex"
}
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  class: "value",
  "data-qe-id": "gametype"
}
const _hoisted_7 = {
  key: 2,
  class: "flex"
}
const _hoisted_8 = { class: "name" }
const _hoisted_9 = {
  class: "value",
  "data-qe-id": "speedSkat"
}
const _hoisted_10 = {
  key: 3,
  class: "flex"
}
const _hoisted_11 = { class: "name" }
const _hoisted_12 = {
  class: "value",
  "data-qe-id": "prize-total"
}
const _hoisted_13 = {
  key: 4,
  class: "flex"
}
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = {
  key: 5,
  class: "flex"
}
const _hoisted_17 = { class: "name" }
const _hoisted_18 = {
  class: "value",
  "data-qe-id": "entry-fee"
}
const _hoisted_19 = {
  key: 6,
  class: "flex"
}
const _hoisted_20 = { class: "name" }
const _hoisted_21 = {
  class: "value",
  "data-qe-id": "restart-fee"
}
const _hoisted_22 = {
  key: 7,
  class: "flex"
}
const _hoisted_23 = { class: "name" }
const _hoisted_24 = {
  class: "value",
  "data-qe-id": "rejoins-remaining"
}
const _hoisted_25 = {
  key: 8,
  class: "flex"
}
const _hoisted_26 = { class: "name" }
const _hoisted_27 = {
  class: "value",
  "data-qe-id": "competition-date"
}
const _hoisted_28 = {
  key: 9,
  class: "flex"
}
const _hoisted_29 = { class: "name" }
const _hoisted_30 = {
  class: "value",
  "data-qe-id": "competition-date-lobby-time"
}
const _hoisted_31 = {
  key: 10,
  class: "flex"
}
const _hoisted_32 = { class: "name" }
const _hoisted_33 = {
  class: "value",
  "data-qe-id": "registration-date"
}
const _hoisted_34 = {
  key: 11,
  class: "flex"
}
const _hoisted_35 = { class: "name" }
const _hoisted_36 = {
  class: "value",
  "data-qe-id": "registration-date"
}
const _hoisted_37 = {
  key: 12,
  class: "flex"
}
const _hoisted_38 = { class: "name" }
const _hoisted_39 = {
  class: "value",
  "data-qe-id": "lobby-time"
}
const _hoisted_40 = {
  key: 13,
  class: "flex"
}
const _hoisted_41 = { class: "name" }
const _hoisted_42 = {
  class: "value",
  "data-qe-id": "competition-mode"
}
const _hoisted_43 = {
  key: 0,
  class: "texts-disclaimer"
}

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { DateFormat } from '@gd/i18n'
import events from '@gd/event-bus'
import { TournamentUi } from '@/model/Tournament'
import { gdcConverter } from '@gd/currency-converter'
import { TournamentStatus } from '../model/TournamentStatus'


export default /*@__PURE__*/_defineComponent({
  __name: 'CTournamentInfo',
  props: {
    tournamentUi: {},
    headline: { default: null },
    rejoin: { type: Boolean, default: false },
    infoIcon: { type: Boolean, default: true },
    gameName: { type: Boolean, default: false },
    totalWin: { type: Boolean, default: false },
    addedPrize: { type: Boolean, default: false },
    entryFee: { type: Boolean, default: false },
    restartFee: { type: Boolean, default: false },
    competitionDate: { type: Boolean, default: false },
    competitionDateLobbyTime: { type: Boolean, default: false },
    lobbyTime: { type: Boolean, default: false },
    registrationDate: { type: Boolean, default: false },
    tournamentMode: { type: Boolean, default: false }
  },
  setup(__props: any) {

// Info section on top of the zone selection page
const props = __props
const { t, d } = useI18n()

/**
 * duplicated from CZoneTournamentItem
 */
const competitionDateStart = computed(() => {
  if (props.tournamentUi.dates) {
    const start = new Date(props.tournamentUi.dates.competitionStart)
    return d(start, DateFormat.DDMMYYY)
  }
  return ''
})

const playersPerGame = computed(() => {
  return props.tournamentUi.metaData.playersPerGame
})

const numberOfGames = computed(() => {
  return props.tournamentUi.metaData.numberOfGames
})

const roundsPerGame = computed(() => {
  return props.tournamentUi.metaData.roundsPerGame
})

const upcomming = computed(() => {
  // TODO the upcomming means only that the competition did not start
  // so this is actually not correct but acceptable
  return props.tournamentUi.tournamentStatus === TournamentStatus.UPCOMING
})

const competitionDateEnd = computed(() => {
  if (props.tournamentUi.dates) {
    const end = new Date(props.tournamentUi.dates.competitionEnd)
    return d(end, DateFormat.DDMMYYY)
  }
  return ''
})

const registrationDateEnd = computed(() => {
  if (props.tournamentUi.dates) {
    const endTime = new Date(props.tournamentUi.dates.registrationEnd)
    return `${d(endTime, DateFormat.DDMMYYY)}`
  }
  return ''
})

const registrationDateStart = computed(() => {
  if (props.tournamentUi.dates) {
    const startTime = new Date(props.tournamentUi.dates.registrationStart)
    return `${d(startTime, DateFormat.DDMMYYY)}`
  }
  return ''
})

const realPrize = computed(() => {
  // Format value only with EUR !!!
  return gdcConverter('125000', { gdc: 'EUR' })
})

const lobbyTimeStart = computed(() => {
  if (props.tournamentUi.dates) {
    const start = new Date(props.tournamentUi.dates.lobbyStart)
    return d(start, DateFormat.MMHH)
  }
  return ''
})
const lobbyTimeEnd = computed(() => {
  if (props.tournamentUi.dates) {
    const end = new Date(props.tournamentUi.dates.lobbyEnd)
    return d(end, DateFormat.MMHH)
  }
  return ''
})
const rejoinsRestricted = computed((): boolean => {
  return !props.tournamentUi.metaData.rejoinsUnlimited
})
const rejoinsRemaining = computed((): number => {
  return props.tournamentUi.metaData.rejoinsRemaining
})
const competitionMode = computed(() => {
  const games = t('tournamentInfo.value.competitionMode_games', numberOfGames.value)
  const rounds = t('tournamentInfo.value.competitionMode_rounds', roundsPerGame.value)
  return t('tournamentInfo.value.competitionMode', { playersPerGame: playersPerGame.value, games, rounds })
})

return (_ctx: any,_cache: any) => {
  return (_ctx.tournamentUi)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.headline)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.headline), 1))
            : _createCommentVNode("", true),
          (_ctx.gameName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('tournamentInfo.label.gameName')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('generic.game.name_' + _ctx.tournamentUi.gametype)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.tournamentUi.gameVariant === 'speed')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('tournamentInfo.label.variant')), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('tournamentInfo.value.variant_speedSkat')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.totalWin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('tournamentInfo.label.totalWin')), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.$t('tournamentInfo.value.totalWin', { totalWin: _ctx.tournamentUi.metaData.totalWin })) + " ", 1),
                  (_ctx.infoIcon && _ctx.tournamentUi.tournamentId)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (
              _unref(events).$emit('tournament-info-modal', {
                tId: _ctx.tournamentUi.tournamentId,
                trackId: 'tournament-info',
              })
            )),
                        class: "icf-info info-icon",
                        "data-qe-id": "win-distribution-trigger"
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.addedPrize && _ctx.tournamentUi.isMasters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('tournamentInfo.label.addedPrize')), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('tournamentInfo.value.addedPrize', {
              numberOfSeats: _ctx.tournamentUi.metaData.numberOfTickets,
              realPrize: realPrize.value,
            })), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.entryFee && !_ctx.rejoin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('tournamentInfo.label.entryFee')), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('tournamentInfo.value.tax_fee', { fee: _ctx.tournamentUi.metaData.entryFee })), 1)
              ]))
            : (_ctx.entryFee && _ctx.rejoin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('tournamentInfo.label.restartFee')), 1),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('tournamentInfo.value.tax_fee', { fee: _ctx.tournamentUi.metaData.restartFee })), 1)
                ]))
              : _createCommentVNode("", true),
          (_ctx.rejoin && rejoinsRestricted.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('tournamentInfo.label.rejoinsRemaining')), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(rejoinsRemaining.value), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.competitionDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('tournamentInfo.label.competitionDate')), 1),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('tournamentInfo.value.competitionDate', {
              competitionDateStart: competitionDateStart.value,
              competitionDateEnd: competitionDateEnd.value,
            })), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.competitionDateLobbyTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('tournamentInfo.label.competitionDate')), 1),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('tournamentInfo.value.competitionDateLobbyTime', {
              competitionDateStart: competitionDateStart.value,
              competitionDateEnd: competitionDateEnd.value,
              lobbyTimeStart: lobbyTimeStart.value,
              lobbyTimeEnd: lobbyTimeEnd.value,
            })), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.registrationDate && upcomming.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('tournamentInfo.label.registrationDate_upcomming')), 1),
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('tournamentInfo.value.registrationDate_upcomming', { registrationDateStart: registrationDateStart.value, registrationDateEnd: registrationDateEnd.value })), 1)
              ]))
            : (_ctx.registrationDate && !upcomming.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('tournamentInfo.label.registrationDate')), 1),
                  _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('tournamentInfo.value.registrationDate', { registrationDateStart: registrationDateStart.value, registrationDateEnd: registrationDateEnd.value })), 1)
                ]))
              : _createCommentVNode("", true),
          (_ctx.lobbyTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('tournamentInfo.label.lobbyTime')), 1),
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('tournamentInfo.value.lobbyTime', { lobbyTimeStart: lobbyTimeStart.value, lobbyTimeEnd: lobbyTimeEnd.value })), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.tournamentMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('tournamentInfo.label.competitionMode')), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(competitionMode.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.tournamentUi.gameVariant === 'speed')
          ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.$t('tournamentInfo.texts.disclaimer_speedSkat')), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})